import { render } from "./EquipmentDetailsPage.vue?vue&type=template&id=2ab281a2"
import script from "./EquipmentDetailsPage.vue?vue&type=script&lang=js"
export * from "./EquipmentDetailsPage.vue?vue&type=script&lang=js"

import "./EquipmentDetailsPage.vue?vue&type=style&index=0&id=2ab281a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__